export default {
  creat: 'Create a task',
  business: 'Business information',
  baseinfo: 'Details',
  qcprice: 'Set a price',
  sample: 'Give a sample',
  tutorial: 'Guidelines',
  note1: 'Unsatisfied about the module?',
  note2: 'Get my customized service!',
  goback: 'Back',
  submit: 'Save',
  next: 'Next',
  js: {
    success: 'Success',
    successNote: 'Submit success',
    error: 'Failure'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/public/pushTask.js